function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
}

export default function copyText(plainText: string, htmlText?: string) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(plainText);
    return;
  }

  const clipboardItems: Record<string, string> = {
    "text/plain": plainText,
  };

  if (htmlText) {
    clipboardItems["text/html"] = htmlText;
  }

  if (typeof ClipboardItem !== "undefined" && navigator.clipboard.write) {
    navigator.clipboard.write([new ClipboardItem(clipboardItems)]);
  } else {
    // Fallback to writeText for plain text only
    navigator.clipboard.writeText(plainText);
  }
}
